import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import './TermsOfServicePage.scss';

const TermsOfServicePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const renderList = (key: string) => {
    const items = t(key, { returnObjects: true }) as string[];
    if (!Array.isArray(items)) return null;
    return (
      <ul>
        {items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
  };

  return (
    <div className="terms-of-service-page">
      <div className="terms-of-service-page__container">
        <button type="button" className="page-back" onClick={() => navigate(-1)} aria-label={t('nav.back')}>
          ← {t('nav.back')}
        </button>
        <h1>{t('termsOfService.title')}</h1>
        <p className="terms-of-service-page__updated">{t('termsOfService.lastUpdated')}</p>

        <nav className="terms-of-service-page__nav" aria-label={t('termsOfService.nav.title')}>
          <h2 className="terms-of-service-page__nav-title">{t('termsOfService.nav.title')}</h2>
          <ul>
            <li><a href="#acceptance">{t('termsOfService.nav.acceptance')}</a></li>
            <li><a href="#nature">{t('termsOfService.nav.nature')}</a></li>
            <li><a href="#responsibilities">{t('termsOfService.nav.responsibilities')}</a></li>
            <li><a href="#subscription">{t('termsOfService.nav.subscription')}</a></li>
            <li><a href="#ai-disclaimer">{t('termsOfService.nav.aiDisclaimer')}</a></li>
            <li><a href="#liability">{t('termsOfService.nav.liability')}</a></li>
            <li><a href="#termination">{t('termsOfService.nav.termination')}</a></li>
            <li><a href="#changes">{t('termsOfService.nav.changes')}</a></li>
          </ul>
        </nav>

        <article>
          <section id="acceptance" className="terms-of-service-page__section">
            <h2>{t('termsOfService.acceptance.title')}</h2>
            <p>{t('termsOfService.acceptance.intro')}</p>
            <p>{t('termsOfService.acceptance.disagree')}</p>
          </section>

          <section id="nature" className="terms-of-service-page__section">
            <h2>{t('termsOfService.nature.title')}</h2>
            <p>{t('termsOfService.nature.intro')}</p>
            <p>{t('termsOfService.nature.purpose')}</p>
            <p>{t('termsOfService.nature.noAdvice')}</p>
          </section>

          <section id="responsibilities" className="terms-of-service-page__section">
            <h2>{t('termsOfService.responsibilities.title')}</h2>
            <p>{t('termsOfService.responsibilities.intro')}</p>
            {renderList('termsOfService.responsibilities.items')}
          </section>

          <section id="subscription" className="terms-of-service-page__section">
            <h2>{t('termsOfService.subscription.title')}</h2>
            <p>{t('termsOfService.subscription.intro')}</p>
            <p>{t('termsOfService.subscription.details')}</p>
            {renderList('termsOfService.subscription.items')}
          </section>

          <section id="ai-disclaimer" className="terms-of-service-page__section">
            <h2>{t('termsOfService.aiDisclaimer.title')}</h2>
            <p>{t('termsOfService.aiDisclaimer.intro')}</p>
            <p><strong>{t('termsOfService.aiDisclaimer.responsibility')}</strong></p>
          </section>

          <section id="liability" className="terms-of-service-page__section">
            <h2>{t('termsOfService.liability.title')}</h2>
            <p>{t('termsOfService.liability.intro')}</p>
            {renderList('termsOfService.liability.items')}
            <p><strong>{t('termsOfService.liability.maxLiability')}</strong></p>
          </section>

          <section id="termination" className="terms-of-service-page__section">
            <h2>{t('termsOfService.termination.title')}</h2>
            <p>{t('termsOfService.termination.intro')}</p>
            {renderList('termsOfService.termination.items')}
          </section>

          <section id="changes" className="terms-of-service-page__section">
            <h2>{t('termsOfService.changes.title')}</h2>
            <p>{t('termsOfService.changes.intro')}</p>
            <p>{t('termsOfService.changes.acceptance')}</p>
          </section>
        </article>

        <div className="terms-of-service-page__footer">
          <Link to="/" className="terms-of-service-page__link">{t('termsOfService.backToHome')}</Link>
          <Link to="/terms" className="terms-of-service-page__link">{t('home.footer.privacy')}</Link>
          <button
            type="button"
            className="terms-of-service-page__link terms-of-service-page__link--btn"
            onClick={() => window.dispatchEvent(new CustomEvent('numerolife:openCookiePreferences'))}
          >
            {t('home.footer.cookies')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
